var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCliente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.997,
    height: 26.989,
    viewBox: "0 0 26.997 26.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cliente",
    transform: "translate(0.114 0.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_017---Self-Star-Rating",
    "data-name": "017---Self-Star-Rating",
    transform: "translate(-0.005 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M23.372,14.786a.446.446,0,1,0,.294.843,8.035,8.035,0,1,0-5.263,0,.446.446,0,1,0,.293-.843A7.123,7.123,0,0,1,16.569,13.6v-.486a3.359,3.359,0,0,1,2.155-3.14,3.992,3.992,0,0,0,4.615,0,3.359,3.359,0,0,1,2.155,3.14V13.6A7.123,7.123,0,0,1,23.372,14.786ZM17.908,6.7a3.124,3.124,0,1,1,3.124,3.124A3.124,3.124,0,0,1,17.908,6.7Zm6.159,2.621a4.017,4.017,0,1,0-6.073,0,4.252,4.252,0,0,0-2.3,3.448,7.141,7.141,0,1,1,10.682,0,4.25,4.25,0,0,0-2.306-3.448Z",
    transform: "translate(-7.641 -0.002)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M19.412,45.1a.886.886,0,0,0,.937.072l2.9-1.509,2.9,1.509a.893.893,0,0,0,1.291-.945L26.9,41.042l2.334-2.25a.893.893,0,0,0-.491-1.526L25.5,36.8l-1.446-2.907a.894.894,0,0,0-1.6,0L21,36.8l-3.233.465a.893.893,0,0,0-.491,1.526l2.335,2.25-.552,3.183a.888.888,0,0,0,.352.872ZM17.894,38.15l3.464-.5a.446.446,0,0,0,.336-.242l1.558-3.117L24.8,37.408a.446.446,0,0,0,.336.243l3.471.5-2.505,2.414a.446.446,0,0,0-.13.4l.592,3.417-3.109-1.616a.446.446,0,0,0-.411,0l-3.11,1.616.592-3.416a.446.446,0,0,0-.13-.4Z",
    transform: "translate(-9.859 -18.495)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M3.095,36.421l-.436,2.521a.806.806,0,0,0,1.167.858l2.3-1.2,2.3,1.2a.446.446,0,1,0,.412-.792L6.336,37.7a.446.446,0,0,0-.412,0L3.568,38.93l.446-2.588a.446.446,0,0,0-.13-.4l-1.9-1.83,2.623-.377a.446.446,0,0,0,.336-.242l1.182-2.363,1.177,2.362a.446.446,0,0,0,.336.243l2.8.4a.446.446,0,1,0,.126-.884L8,32.887l-1.15-2.308a.8.8,0,0,0-.723-.446h0a.794.794,0,0,0-.714.444L4.255,32.887l-2.563.368a.8.8,0,0,0-.446,1.379Z",
    transform: "translate(-0.995 -16.686)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M48.608,33.8a.8.8,0,0,0-.652-.547l-2.566-.368-1.153-2.31a.8.8,0,0,0-.714-.446h0a.8.8,0,0,0-.724.446l-1.15,2.308-2.571.368a.446.446,0,1,0,.126.884l2.8-.4a.446.446,0,0,0,.336-.243l1.175-2.359,1.18,2.363a.446.446,0,0,0,.336.242l2.621.376-1.9,1.83a.446.446,0,0,0-.13.4l.449,2.588L43.72,37.7a.446.446,0,0,0-.412,0L40.8,39.006a.446.446,0,1,0,.412.792l2.3-1.2,2.3,1.2a.807.807,0,0,0,1.167-.856l-.435-2.526,1.85-1.785A.8.8,0,0,0,48.608,33.8Z",
    transform: "translate(-21.869 -16.683)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M24.948,43.8a.453.453,0,0,0,.064,0l1.678-.241a.446.446,0,0,0,.336-.242l.777-1.553a.447.447,0,0,0-.8-.4L26.335,42.7l-1.448.208a.446.446,0,0,0,.063.888Z",
    transform: "translate(-14.012 -22.766)",
    stroke: "#000",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliente);
export default __webpack_public_path__ + "static/media/cliente.b658b6fa48721e2e4a410662bed4a317.svg";
export { ForwardRef as ReactComponent };